"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXxs, SpaceXs, SpaceMd, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
const PaginationDotsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: ColorWhite,
  borderRadius: "100px",
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "auto",
  marginTop: SpaceMd,
  padding: `${SpaceXxs} ${SpaceXs}`,
  width: "fit-content",
  [theme.breakpoints.down("md")]: {
    padding: `0 ${SpaceXxs}`
  }
}));
const NavigationButtonBottomAlignContainer = styled(Box)(() => {
  return {
    marginBottom: "41px"
  };
});
export {
  NavigationButtonBottomAlignContainer,
  PaginationDotsWrapper
};
